/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelconfirmtitle2Inputs */

const en_channelconfirmtitle2 = /** @type {(inputs: Channelconfirmtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send broadcast?`)
};

const de_channelconfirmtitle2 = /** @type {(inputs: Channelconfirmtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast senden?`)
};

/**
* | output |
* | --- |
* | "Send broadcast?" |
*
* @param {Channelconfirmtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelconfirmtitle2 = /** @type {((inputs?: Channelconfirmtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelconfirmtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelconfirmtitle2(inputs)
	return de_channelconfirmtitle2(inputs)
});
export { channelconfirmtitle2 as "channelConfirmTitle" }